<template>
<div class="chapter">
<div class="inner_page">
<h3 class="books-by-head"><em>Recent Titles by Janet Woods from Severn House</em></h3>
<p class="books-by-text"><span class="small">AMARANTH MOON</span></p>
<p class="books-by-text"><span class="small">BROKEN JOURNEY</span></p>
<p class="books-by-text"><span class="small">CINNAMON SKY</span></p>
<p class="books-by-text"><span class="small">THE COAL GATHERER</span></p>
<p class="books-by-text"><span class="small">EDGE OF REGRET</span></p>
<p class="books-by-text"><span class="small">HEARTS OF GOLD</span></p>
<p class="books-by-text"><span class="small">LADY LIGHTFINGERS</span></p>
<p class="books-by-text"><span class="small">MORE THAN A PROMISE</span></p>
<p class="books-by-text"><span class="small">PAPER DOLL</span></p>
<p class="books-by-text"><span class="small">SALTING THE WOUND</span></p>
<p class="books-by-text"><span class="small">SECRETS AND LIES</span></p>
<p class="books-by-text"><span class="small">THE STONECUTTER’S DAUGHTER</span></p>
<p class="books-by-text"><span class="small">STRAW IN THE WIND</span></p>
<p class="books-by-text"><span class="small">TALL POPPIES</span></p>
<p class="books-by-text-space-after"><span class="small">WITHOUT REPROACH</span></p>
<div> </div>
<div> </div>
<p class="books-by-text">The author invites comments from her readers</p>
<p class="books-by-text">via her website:</p>
<p class="books-by-text"><a href="http://www.janet-woods.com" target="_blank">www.janet-woods.com</a></p>
<p class="books-by-text">or by post:</p>
<p class="books-by-text">PO Box 2099</p>
<p class="books-by-text">Kardinya 6163</p>
<p class="books-by-text">Western Australia</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsoby.vue?43c5004c